import React from "react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { CurrencyNote } from "../CurrencyNote";
import { TrustRow } from "../TrustRow";
import { IconByName } from "../IconByName";
import { finalIncludes } from "../../data/content";
export function FinalCtaSection() {
  return <section className="bg-navy-900 px-5 py-16 text-white sm:py-20" data-id="element-151" data-mp="2dlpss7weyuei">
      <div className="mx-auto max-w-2xl" data-id="element-152" data-mp="2rhjsq1f7m9fh">
        <p className="text-center text-[13px] font-extrabold uppercase tracking-[0.12em] text-brand-light" data-id="element-153" data-mp="2mk1im7pgho5w">
          Your next step toward more confident whitening decisions
        </p>
        <h2 className="mt-4 text-center font-display text-[30px] font-black leading-[1.1] tracking-tight [text-wrap:balance] sm:text-[42px]" data-id="element-154" data-mp="31as6j4nxg33q">
          Stop Relying on Scattered Information. <span className="text-brand-light" data-id="element-155" data-mp="3a9vuon1yb8p3">Start Learning From a Structured Clinical Blueprint.</span>
        </h2>
        <p className="mt-5 text-center text-[17px] leading-relaxed text-white/80" data-id="element-156" data-mp="3667jlue41uz3">
          You need an organized resource that helps you understand the clinical reasoning behind patient assessment, technique selection,
          sensitivity management, and treatment evaluation. That's what DENTAL BLEACHING BLUEPRINT™ is designed to provide.
        </p>

        <div className="mt-8 rounded-3xl bg-navy-800 p-5 sm:p-7" data-id="element-157" data-mp="2g1585qxz3k03">
          <p className="font-display text-[20px] font-black" data-id="element-158" data-mp="2kzynzq0qfn3f">Get your complete clinical collection today</p>
          <ul className="mt-4 space-y-3" data-id="element-159" data-mp="2p08tz2oiydia">
            {finalIncludes.map(f => <li key={f.label} className="flex items-center gap-3 text-[15px] font-semibold" data-id="element-160" data-mp="2ts0iz8s18b6b">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand/20 text-brand-light" data-id="element-161" data-mp="2yqk8fj5u453f">
                  <IconByName name={f.icon} className="h-4 w-4" data-id="element-162" data-mp="33qzlsaq49cle" />
                </span>
                {f.label}
              </li>)}
          </ul>
          <div className="mt-6 border-t border-white/10 pt-5 text-center" data-id="element-163" data-mp="2j0vo5uto3phi">
            <p className="text-[15px] text-white/70" data-id="element-164" data-mp="2iyrm7ifbx0jv">
              Total suggested value: <span className="font-bold text-white/80 line-through" data-id="element-165" data-mp="2e33zras8eli2">$251 USD</span>
            </p>
            <p className="mt-1 font-display text-[44px] font-black leading-none text-gold" data-id="element-166" data-mp="2srgszzzxpq8v">$27 USD</p>
            <p className="mt-2 text-[14px] font-semibold text-white/80" data-id="element-167" data-mp="2nye07u2zektq">One-Time Payment • Lifetime Digital Access</p>
          </div>
        </div>

        <div className="mt-7" data-id="element-168" data-mp="2wsixav8pkshp">
          <CtaButton label="Yes! I want the Dental Bleaching Blueprint™" sublabel="Instant access to all 6 volumes + 5 bonuses" data-id="element-169" data-mp="2wr8whyah167d" />
          <TrustRow tone="dark" items={["Digital Access", "Secure Checkout", "One-Time Payment", "7-Day Guarantee"]} data-id="element-170" data-mp="3borsnlphalou" />
          <Countdown tone="dark" label="Special offer ends in:" data-id="element-171" data-mp="36olzg13k8r4n" />
          <ScarcityBar tone="dark" data-id="element-172" data-mp="1hc1zj66xpgii" />
          <CurrencyNote tone="dark" data-id="element-173" data-mp="1hdd0ky8zwa5x" />
        </div>
      </div>
    </section>;
}